<script setup lang="ts">
/**
 * Dezenter Hinweis, wenn eine neue Fassung des Panels bereitliegt.
 *
 * Bewusst KEIN Dialog: er würde unterbrechen. Wer gerade einen Text tippt,
 * aktualisiert, wenn es passt. Ist niemand am Bildschirm und nichts
 * ungespeichert, lädt sich das Panel ohnehin still selbst neu — dann wird
 * dieser Balken nie sichtbar.
 *
 * AUF DEM HANDY (seit 02.10.2026): Der Text darf umbrechen, der Knopf nicht,
 * und breiter als der Bildschirm minus Rand wird der Balken nie. Vorher stand
 * er bei 320 px 16 px links aus dem Bild, und der Knopf ragte bei jeder Breite
 * aus der Pille (UpdateBanner.browser.spec.ts misst das).
 *
 * EBENE z-20: über Editor und Vorschau (z-10), unter allem, was sich darüber
 * öffnet (Kopfzeile und Hintergründe ab z-30, Fenster und Schubladen ab z-40).
 * Vorher z-[9998]: Damit lag der Balken auch über einem offenen Fenster, auf
 * dem Handy über dem unten verankerten Katalog-Formular.
 */
import { useI18n } from 'vue-i18n'
import { useVersionWatch } from '@/composables/useVersionWatch'

const { t } = useI18n()
const { neueFassungDa, anwenden } = useVersionWatch()
</script>

<template>
  <div
    v-if="neueFassungDa"
    class="fixed bottom-4 left-1/2 z-20 flex w-max max-w-[calc(100vw-2rem)] -translate-x-1/2 items-center gap-3 rounded-2xl bg-fg px-4 py-2.5 text-sm font-medium text-bg shadow-lg sm:rounded-full"
    role="status"
  >
    <span>{{ t('update.available') }}</span>
    <button
      type="button"
      class="shrink-0 whitespace-nowrap rounded-full bg-bg px-3 py-1.5 text-xs font-semibold text-fg hover:opacity-90"
      @click="anwenden"
    >
      {{ t('update.action') }}
    </button>
  </div>
</template>
